import React from 'react';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import { Formik } from 'formik';
import OfferEligibilitySelection from '../../../offers/offer-create/OfferEligibility';
import Kickback from '../../../offers/offer-create/Kickback';
import OfferName from '../../../offers/offer-create/OfferName';
import CreateOfferActions from '../../../offers/offer-create/CreateOfferActions';
import { useGetOffer } from 'legacy/events/hooks';
import AdvancedOfferOptions from '../../../offers/offer-create/AdvanceOfferOptions';
import LoadingOfferSkeleton from '../../../offers/OfferLoadingSkeleton';
import { OffersStep } from 'legacy/events/offers.types';
import { offerValidationSchema } from './helper/validationSchema';
import { getInitialValues } from './helper/offerInitialValues';
import { useOfferFormSubmission } from './hooks/useOfferFormSubmission';

interface CreateOfferPageProps {
  eventId: string;
  offerId?: string;
  setOffersStep: (step: OffersStep) => void;
}

const CreateOfferPage = ({
  eventId,
  offerId,
  setOffersStep
}: CreateOfferPageProps) => {
  const isEditMode = !!offerId;

  const { data: existingOffer, isLoading } = useGetOffer(offerId || '', {
    enabled: isEditMode
  });

  const initialValues = getInitialValues(isEditMode, existingOffer);

  const { handleSubmit } = useOfferFormSubmission({
    eventId,
    offerId,
    isEditMode,
    initialValues,
    setOffersStep
  });

  if (isEditMode && isLoading) {
    return <LoadingOfferSkeleton />;
  }

  return (
    <>
      <Formik
        validationSchema={offerValidationSchema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, dirty }) => (
          <>
            <FadeIn>
              <div className="pt-[36x] md:pt-[90px] -mt-[36px] pb-20 md:w-[630px] md:mx-auto">
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-row mt-4 mb-4 ml-4 mr-4">
                    <div className="w-full flex flex-col">
                      <OfferName />
                      <Kickback />
                      <OfferEligibilitySelection />
                      <AdvancedOfferOptions eventId={eventId} />
                    </div>
                  </div>
                </form>
              </div>
            </FadeIn>
            <CreateOfferActions
              handleSubmit={handleSubmit}
              isEditMode={isEditMode}
              disabled={isEditMode && !dirty}
            />
          </>
        )}
      </Formik>
    </>
  );
};

export default CreateOfferPage;
